import MarkdownContent from "@/components/markdown-content";

export default function ChatbotMessageContent({ className = "", content = "", role }) {
  const classes = [className, role === "assistant" ? "chatbot-markdown" : ""].filter(Boolean).join(" ");

  if (role !== "assistant") {
    return (
      <div className={classes} style={{ whiteSpace: "pre-wrap" }}>
        {content}
      </div>
    );
  }

  return <MarkdownContent className={classes} content={content} />;
}
